import { HomeOutlined } from '@ant-design/icons';
import * as React from 'react';

export const HomeIcon = props => (
  <HomeOutlined {...props} />
);
